module.exports = __webpack_public_path__ + "img/tow_2.ac74a388.png";